import { useParams, useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { FeedbackPage } from './FeedbackPage';
import { PatientRouteParams } from '../router';
import NavBar, { View } from '../../components/NavBar';
import { withFetchPatient } from '../../components/hoc/withFetchPatient';
import * as store from '../../reducers/store';
import { getFormEndPath } from '../../utils/form';
import Header from '../Schedule/Form/Header';
import { useBookedSlot } from '../../hooks/schedule/useBookedSlot';

import styles from '../FormStart/index.module.css';

export const FeedbackComponent: React.FC = () => {
  const { authenticationCode } = useParams<PatientRouteParams>();
  const history = useHistory();
  const location = useLocation();
  const multiFormSet = useSelector((state: store.All) => state.multiFormSet);
  const { selectedEhrProviderWithPractice, selectedTimeSlot } = useBookedSlot();

  const navigateToNextPage = () => {
    const queryParams = new URLSearchParams(location.search.slice(1));
    queryParams.delete('page');
    history.push({
      pathname: authenticationCode
        ? getFormEndPath(authenticationCode, multiFormSet)
        : history.location.pathname.replace('feedback', 'end'),
      search: authenticationCode ? '' : queryParams.toString(),
    });
  };

  return (
    <>
      <NavBar view={View.FormStart} />
      {selectedEhrProviderWithPractice ? (
        <Header
          providerConfig={selectedEhrProviderWithPractice}
          selectedEhrTimeSlot={selectedTimeSlot ?? null}
        />
      ) : null}
      <div
        className={classNames(
          styles.FormContainer,
          selectedEhrProviderWithPractice ? styles.SchedulingForm : undefined,
        )}
      >
        <div className={styles.Form}>
          <FeedbackPage navigateToNextPage={navigateToNextPage} />
        </div>
      </div>
    </>
  );
};

export default withFetchPatient(FeedbackComponent);
export const FeedbackMulti = withFetchPatient(FeedbackComponent, {
  multi: true,
});
